import type { OptionsEntries } from '@edge/spark/feature-mui-rhf-inputs'

export enum SaleStatusValuesEnum {
    ARBITRATION = 'arbitration',
    AVAILABLE = 'available',
    CONSIGNED = 'consigned',
    EXITED = 'exited',
    INVENTORY = 'inventory',
    OFFER = 'offer',
    REDEEMED = 'redeemed',
    RETURNED = 'returned',
    SOLD = 'sold',
}

export enum SaleStatusLabelsEnum {
    ARBITRATION = 'Arbitration',
    AVAILABLE = 'Available',
    CONSIGNED = 'Consigned',
    EXITED = 'Exited',
    INVENTORY = 'Inventory',
    OFFER = 'If/Offer',
    REDEEMED = 'Redeemed',
    RETURNED = 'Returned',
    SOLD = 'Sold',
}

export enum OperatorsValuesEnum {
    BETWEEN = 'range',
    EQUAL_TO = 'equals',
    GREATER_THAN = 'above',
    LESS_THAN = 'below',
    NOT_EQUAL_TO = 'notequal',
}

export enum OperatorsLabelsEnum {
    BETWEEN = 'Between',
    EQUAL_TO = 'Equals',
    GREATER_THAN = 'Greater Than',
    LESS_THAN = 'Less Than',
    NOT_EQUAL_TO = 'notequal',
}

export enum BinaryOperatorsValuesEnum {
    EQUAL_TO = 'equals',
    NOT_EQUAL_TO = 'notequal',
}

export enum AccountRepValuesEnum {
    REP = 'rep',
    REP_SELLER = 'repseller',
    REP_BUYER = 'repbuyer',
}

export enum RepAccountsValuesEnum {
    ALL_ACCOUNTS = 'All Accounts',
    SELLER_ACCOUNTS = 'Seller Accounts',
    BUYER_ACCOUNTS = 'Buyer Accounts',
}

export enum RepTypesValuesEnum {
    ALL = 'ALL',
    SELLER = 'SELLER',
    BUYER = 'BUYER',
}

export enum BinaryOperatorsLabelsEnum {
    EQUAL_TO = 'Includes',
    NOT_EQUAL_TO = 'Excludes',
}

export enum MetricValuesEnum {
    AVG_SALE_AMOUNT = 'avgSaleAmount',
    CONVERSION = 'conversion',
    NONE = 'none',
    RAN = 'ran',
    SOLD = 'sold',
    SUM_SALE_AMOUNT = 'sumSaleAmount',
    TOTAL = 'total',
}

export enum MetricLabelsEnum {
    AVG_SALE_AMOUNT = 'Avg Sales',
    CONVERSION = 'Conversion',
    NONE = 'N/A',
    RAN = 'Ran',
    SOLD = 'Sold',
    SUM_SALE_AMOUNT = 'Sum Sales',
    TOTAL = 'Total',
}

export const yearOptions: OptionsEntries = [
    ['', 'Years'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const odometerOptions: OptionsEntries = [
    ['', 'Miles'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const photosOptions: OptionsEntries = [
    ['', 'Photos'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const yesNoOptions: OptionsEntries = [
    ['', 'N/A'],
    ['yes', 'YES'],
    ['no', 'NO'],
]

export const contactStatusOptions: OptionsEntries = [
    ['', 'N/A'],
    ['followup', 'Follow Up Required'],
    ['noaction', 'No Action'],
    ['completed', 'Completed'],
]

export const contactMethodOptions: OptionsEntries = [
    ['', 'N/A'],
    ['phone', 'Phone'],
    ['email', 'Email'],
    ['share', 'Share'],
    ['inperson', 'In Person'],
    ['voicemail', 'Left Voicemail'],
    ['text', 'Text'],
]

export const binaryFilterOptions: OptionsEntries = [
    ['', ''],
    [BinaryOperatorsValuesEnum.EQUAL_TO, BinaryOperatorsLabelsEnum.EQUAL_TO],
    [BinaryOperatorsValuesEnum.NOT_EQUAL_TO, BinaryOperatorsLabelsEnum.NOT_EQUAL_TO],
]

// TODO: Remove once repsellerNot & repbuyerNot are implemented
export const equalFilterOptions: OptionsEntries = [
    ['', ''],
    [BinaryOperatorsValuesEnum.EQUAL_TO, BinaryOperatorsLabelsEnum.EQUAL_TO],
]

export const repTypeOptions: OptionsEntries = [
    [RepTypesValuesEnum.ALL, RepAccountsValuesEnum.ALL_ACCOUNTS],
    [RepTypesValuesEnum.SELLER, RepAccountsValuesEnum.SELLER_ACCOUNTS],
    [RepTypesValuesEnum.BUYER, RepAccountsValuesEnum.BUYER_ACCOUNTS],
]

export const saleStatusOptions: OptionsEntries = [
    [SaleStatusValuesEnum.ARBITRATION, SaleStatusLabelsEnum.ARBITRATION],
    [SaleStatusValuesEnum.AVAILABLE, SaleStatusLabelsEnum.AVAILABLE],
    [SaleStatusValuesEnum.CONSIGNED, SaleStatusLabelsEnum.CONSIGNED],
    [SaleStatusValuesEnum.EXITED, SaleStatusLabelsEnum.EXITED],
    [SaleStatusValuesEnum.INVENTORY, SaleStatusLabelsEnum.INVENTORY],
    [SaleStatusValuesEnum.OFFER, SaleStatusLabelsEnum.OFFER],
    [SaleStatusValuesEnum.REDEEMED, SaleStatusLabelsEnum.REDEEMED],
    [SaleStatusValuesEnum.RETURNED, SaleStatusLabelsEnum.RETURNED],
    [SaleStatusValuesEnum.SOLD, SaleStatusLabelsEnum.SOLD],
]

export const metricOptions: OptionsEntries = [
    ['', 'Select One...'],
    [MetricValuesEnum.NONE, MetricLabelsEnum.NONE],
    [MetricValuesEnum.AVG_SALE_AMOUNT, MetricLabelsEnum.AVG_SALE_AMOUNT],
    [MetricValuesEnum.CONVERSION, MetricLabelsEnum.CONVERSION],
    [MetricValuesEnum.RAN, MetricLabelsEnum.RAN],
    [MetricValuesEnum.SOLD, MetricLabelsEnum.SOLD],
    [MetricValuesEnum.SUM_SALE_AMOUNT, MetricLabelsEnum.SUM_SALE_AMOUNT],
    [MetricValuesEnum.TOTAL, MetricLabelsEnum.TOTAL],
]

export const ranCountOptions: OptionsEntries = [
    ['', 'Ran Count'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const lotOptions: OptionsEntries = [
    ['', 'Lot'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const floorOptions: OptionsEntries = [
    ['', 'Floor'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const mmrOptions: OptionsEntries = [
    ['', 'MMR'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]

export const blackbookOptions: OptionsEntries = [
    ['', 'Blackbook'],
    [OperatorsValuesEnum.BETWEEN, OperatorsLabelsEnum.BETWEEN],
    [OperatorsValuesEnum.EQUAL_TO, OperatorsLabelsEnum.EQUAL_TO],
    [OperatorsValuesEnum.GREATER_THAN, OperatorsLabelsEnum.GREATER_THAN],
    [OperatorsValuesEnum.LESS_THAN, OperatorsLabelsEnum.LESS_THAN],
]
